var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlayCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2731_1703",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 22,
    height: 22
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2731_1703)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.71289 15.125L15.1296 11L8.71289 6.87498V15.125ZM11.0046 20.1666C9.7365 20.1666 8.54483 19.926 7.42956 19.4448C6.31428 18.9635 5.34414 18.3104 4.51914 17.4854C3.69414 16.6604 3.04102 15.6903 2.55977 14.575C2.07852 13.4597 1.83789 12.268 1.83789 11C1.83789 9.73192 2.07852 8.54026 2.55977 7.42498C3.04102 6.3097 3.69414 5.33956 4.51914 4.51456C5.34414 3.68956 6.31428 3.03644 7.42956 2.55519C8.54483 2.07394 9.7365 1.83331 11.0046 1.83331C12.2726 1.83331 13.4643 2.07394 14.5796 2.55519C15.6948 3.03644 16.665 3.68956 17.49 4.51456C18.315 5.33956 18.9681 6.3097 19.4493 7.42498C19.9306 8.54026 20.1712 9.73192 20.1712 11C20.1712 12.268 19.9306 13.4597 19.4493 14.575C18.9681 15.6903 18.315 16.6604 17.49 17.4854C16.665 18.3104 15.6948 18.9635 14.5796 19.4448C13.4643 19.926 12.2726 20.1666 11.0046 20.1666Z",
    fill: "#1A4CFF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayCircle);
export default __webpack_public_path__ + "static/media/play_circle.0951946aa625b8a64067f247dd6ca6e4.svg";
export { ForwardRef as ReactComponent };